import { useEffect, useState, type ReactElement, type ReactNode } from 'react';
import type { ThemeMode } from '../hooks/useTheme';
import { RightRail } from './RightRail';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

interface LayoutProps {
  children: ReactNode;
  theme: ThemeMode;
  onThemeChange: (theme: ThemeMode) => void;
}

export function Layout({ children, theme, onThemeChange }: LayoutProps): ReactElement {
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    document.body.dataset.drawerOpen = menuOpen ? 'true' : 'false';
    return () => { delete document.body.dataset.drawerOpen; };
  }, [menuOpen]);
  return <div className="min-h-screen bg-canvas text-ink"><TopBar theme={theme} onThemeChange={onThemeChange} onOpenMenu={() => setMenuOpen(true)} /><div className="mx-auto grid max-w-[1540px] grid-cols-1 gap-8 px-4 sm:px-6 lg:grid-cols-[220px_minmax(0,1fr)] lg:px-8 xl:grid-cols-[220px_minmax(0,1fr)_290px] xl:gap-10"><Sidebar open={menuOpen} onClose={() => setMenuOpen(false)} /><main className="min-w-0 py-7 sm:py-9">{children}</main><RightRail /></div></div>;
}
